import { LoginRequest } from 'client/features/session/actions'
import { reducer as formReducer } from 'redux-form'

const reducer = formReducer.plugin({
    login: (state, action) => {
        switch(action.type) {

        case LoginRequest.post.TYPES.FAILURE:
            return { ...state, error: action.payload.error }
                
        default:
            return state
        }
    }
})

export default reducer


// WEBPACK FOOTER //
// ./src/client/features/form/reducers.js